import { render, staticRenderFns } from "./ResendHistoryListTab.vue?vue&type=template&id=0ddd7388&lang=pug"
import script from "./ResendHistoryListTab.vue?vue&type=script&lang=ts"
export * from "./ResendHistoryListTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports